export enum TimesheetViewType {
  Manager = "Manager",
  Payroll = "Payroll",
  TimesheetAdmin = "TimesheetAdmin"
}
